import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'familyPlanLanding.hero.heading',
		defaultMessage: 'A Calm family is a happy family',
		description: 'Explanation of what family plan is',
	},
	headingAccept: {
		id: 'familyPlanLanding.hero.headingFamilyAccept',
		defaultMessage: '{name} has invited you to join their Calm Family Plan.',
		description: 'Explanation of what family plan is',
	},
	headingAcceptNoName: {
		id: 'familyPlanLanding.hero.headingFamilyAcceptNoName',
		defaultMessage: 'You have been invited to join a Calm Family Plan.',
		description: 'Explanation of what family plan is',
	},
	subheading: {
		id: 'familyPlanLanding.hero.subheading',
		defaultMessage: 'Six Premium accounts for {price}/year.',
		description: 'Pricing for family plan',
	},
	cta: {
		id: 'familyPlanLanding.hero.cta',
		defaultMessage: 'Get Premium Family',
		description: 'Button which leads user to payment form',
	},
	ctaAccept: {
		id: 'familyPlanLanding.hero.ctaAccept',
		defaultMessage: 'Accept Invite',
		description: 'Button which leads user to payment form',
	},
	ctaClose: {
		id: 'familyPlanLanding.hero.ctaClose',
		defaultMessage: 'No Thanks',
		description: 'Button which closes the modal',
	},
});
